import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import SpaceTypeFilter from '../components/SpaceTypeFilter'
import PropTypes from 'prop-types'
import NewPropertyFilter from '../components/NewPropertyFilter'
import MoveInFilter from '../components/MoveInFilter'
import PeopleAmountFilter from '../components/PeopleAmountFilter'
import FloorAreasFilter from '../components/FloorAreasFilter'
import { media } from '../../search-common/helpers'
import { colors } from '../../search-common/settings'

const SHOW_MOVEIN_FILTER = false

const Container = styled.div`
  width: 100%;
  min-width: 300px;
  color: ${colors.white};
  margin: 0;
  position: relative;
  padding: 0 24px;
  vertical-align: middle;
  ${media.tablet`
    display: flex;
    gap: 12px;
    justify-content: flex-start;
  `}
`

const ItemContainer = styled.div`
  margin: 0;

  & + & {
    margin-top: 2px;
  }

  ${media.tablet`
    flex: 1 1 0;
    margin: auto 0;
    min-width: 0;

    & + & {
      margin-top: auto;
    }
  `}
  ${( props ) => props.styles}
`

const BooleanFilterGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding-top: 12px;

  @media (max-width: 499px) {
    flex-direction: column;
    gap: 10px;
  }

  > div {
    flex: 1 1 0;
    min-width: 0;
    padding-top: 0;
  }

  ${media.tablet`
    flex-direction: column;
    gap: 10px;
    padding-top: ${( props ) => props.$singleVisibleFilter ? '26px' : '6px'};
  `}
`

const HiddenMoveInFilterSlot = styled.div`
  display: none;
`

/**
 * Filters container.
 */
const Filters = ({ className, moveInAvailable }) => {
  const showMoveInFilter = SHOW_MOVEIN_FILTER && moveInAvailable

  return (
    <Container className={className}>
      <ItemContainer>
        <SpaceTypeFilter />
      </ItemContainer>
      <ItemContainer>
        <PeopleAmountFilter />
      </ItemContainer>
      <ItemContainer>
        <FloorAreasFilter />
      </ItemContainer>
      <ItemContainer>
        <BooleanFilterGroup $singleVisibleFilter={!showMoveInFilter}>
          <NewPropertyFilter />
          {moveInAvailable && (
            showMoveInFilter ?
              <MoveInFilter /> :
              <HiddenMoveInFilterSlot>
                <MoveInFilter />
              </HiddenMoveInFilterSlot>
          )
          }
        </BooleanFilterGroup>
      </ItemContainer>
    </Container>
  )
}

Filters.propTypes = {
  className: PropTypes.any,
  moveInAvailable: PropTypes.bool.isRequired
}

/**
 * Map the redux state to component props.
 *
 * @return {object}
 */
const mapStateToProps = ( state ) => {
  const moveIn = state.search.initial && state.search.initial.movein
  return {
    moveInAvailable: Boolean( moveIn && moveIn.has_spaces )
  }
}

export default connect(
  mapStateToProps
)( Filters )
